import { Progress, Ranks, Staffs, Plans, Question } from './SearchData';

import { ResultData } from './SearchData';

export const PROGRESS: Progress[] = [
    {status: '初回面談予約済'},
    {status: '初回面談未実施'},
    {status: '初回面談済'},
    {status: '追客アポ無'},
    {status: '追客アポ有'},
    {status: '申込済アポ無'},
    {status: '申込済'},
    {status: '契約済'},
    {status: '着工済'},
    {status: '引渡済'},
    {status: 'アフター１回目'},
    {status: 'アフター２回目 １年点検'},
    {status: 'アフター３回目 ２年点検'},
    {status: '失注'},
];

export const RANKS: Ranks[] = [
    {rank: 'A'},
    {rank: 'B'},
    {rank: 'C'},
    {rank: 'D'},
    {rank: 'E'},
    {rank: 'F'},
    {rank: 'X'},
];

export const STAFFS: Staffs[] = [
    {name: '山田太郎', division: 'ニコニコ'},
    {name: '田中次郎', division: '平屋'},
    {name: '宮本三郎', division: 'みらい'}
];

export const PLANS: Plans[] = [
    {plan: '平屋'},
    {plan: '平屋B'},
    {plan: '２階建て'},
    {plan: '３階建て'},
    {plan: 'その他'}
]

export const QUESTION: Question[] = [
    {answer: 'ホームページ'},
    {answer: 'チラシ'},
    {answer: '駅看板'},
    {answer: '店舗看板'},
    {answer: '紹介'},
    {answer: 'その他'}
]

export const RESULTDATA: ResultData[] = [
    /*{
        id: 1,
        client: '日高',
        plan: '２階建て',
        age: 32,
        rank: 'D',
        staff: '山田太郎',
        totalP: 1000,
        status: '追客アポ無',
        landP: 1111,
        familyAge: 30,
        fundP: 1222,
        trigger: 'ホームページ',
        planP: 1333,
        elapsed: 1444,
        conflictP: 1555,
        change: 1666,
        affected: 1777,
        timing: 1888,
    },
    {
        id: 2,
        client: '吉田',
        plan: '平屋',
        age: 22,
        rank: 'A',
        staff: '宮本三郎',
        totalP: 5000,
        status: '引渡済',
        landP: 5111,
        familyAge: 50,
        fundP: 5222,
        trigger: 'ホームページ',
        planP: 5333,
        elapsed: 5444,
        conflictP: 5555,
        change: 5666,
        affected: 5777,
        timing: 5888,
    },
    {
        id: 3,
        client: '日高',
        plan: '２階建て',
        age: 17,
        rank: 'A',
        staff: '山田太郎',
        totalP: 3000,
        status: '契約済',
        landP: 3111,
        familyAge: 40,
        fundP: 3222,
        trigger: 'ホームページ',
        planP: 3333,
        elapsed: 3444,
        conflictP: 3555,
        change: 3666,
        affected: 3777,
        timing: 3888,
    }*/
]
